<template>
  <section>
    <div>
      <div>
        <!-- Funcionalidad restringida a plan Corporate -->
        <div
          v-if="!general.isCorporatePlan"
          class="flex flex-col items-center justify-center py-12 mt-2 text-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-12 w-12 text-gray-200 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          <p class="text-gray-500 text-sm max-w-md">
            La gestión de múltiples academias solo está disponible en el plan Corporate.
            Contacta con nuestro equipo de soporte para más información.
          </p>
          <a
            href="mailto:soporte@brainspro.com"
            class="mt-3 text-bpblue hover:text-blue-400 transition-colors text-sm font-medium underline"
          >
            soporte@brainspro.com
          </a>
        </div>

        <template v-else>
        <!-- Estado vacío -->
        <div
          v-if="!general.loading && academies.length === 0"
          class="flex flex-col items-center justify-center py-12 mt-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-12 w-12 text-gray-200 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
          <p class="text-gray-400 text-sm">
            No tienes ninguna academia disponible.
          </p>
        </div>

        <!-- Tabla de academias -->
        <div
          v-if="academies.length > 0"
          class="mt-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <div
            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
          >
            <table class="min-w-full">
              <thead>
                <tr>
                  <th
                    class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Academia
                  </th>
                  <th
                    class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Seleccionada
                  </th>
                  <th
                    class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Subdominio
                  </th>
                  <th
                    class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Estado
                  </th>
                  <th
                    class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    <!-- Acciones -->
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="academy in academies"
                  :key="academy.uuid"
                  class="hover:bg-gray-50 transition-colors"
                >
                  <td
                    class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                  >
                    <div class="flex items-center">
                      <div
                        v-if="academy.branding && academy.branding.logo_url"
                        class="flex-shrink-0 h-10 w-10 mr-3"
                      >
                        <img
                          class="h-10 w-10 rounded-full object-cover"
                          :src="academy.branding.logo_url"
                          :alt="academy.title"
                        />
                      </div>
                      <div
                        v-else
                        class="flex-shrink-0 h-10 w-10 mr-3 bg-bpblue rounded-full flex items-center justify-center"
                      >
                        <span class="text-white text-sm font-bold">{{
                          academy.title
                            ? academy.title.charAt(0).toUpperCase()
                            : "A"
                        }}</span>
                      </div>
                      <div>
                        <div
                          class="text-sm leading-5 font-medium text-gray-900"
                        >
                          {{ academy.title }}
                        </div>
                        <div
                          v-if="academy.tagline"
                          class="text-xs leading-4 text-gray-400"
                        >
                          {{ academy.tagline }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <!-- Columna academia seleccionada -->
                  <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                    <span
                      v-if="academy.uuid === selectedAcademyUuid"
                      class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-bpblue text-white"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      Seleccionada
                    </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                  >
                    <div class="text-sm leading-5 text-gray-500">
                      <a
                        v-if="academy.url"
                        :href="academy.url"
                        target="_blank"
                        class="text-bpblue hover:text-blue-400 transition-colors"
                      >
                        {{ academy.subdomain }}
                      </a>
                      <span v-else>{{ academy.subdomain }}</span>
                    </div>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                  >
                    <span
                      v-if="academy.is_main_saas_subscription_active"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                    >
                      Activa
                    </span>
                    <span
                      v-else
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
                    >
                      Inactiva
                    </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-right text-sm font-medium"
                  >
                    <a
                      v-if="academy.url"
                      :href="academy.url"
                      target="_blank"
                      title="Ir a la academia"
                      class="text-bpblue hover:text-blue-400 transition-colors mr-3"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 inline"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </a>
                    <button
                      v-if="academy.uuid !== selectedAcademyUuid"
                      type="button"
                      title="Cambiar a esta academia"
                      @click="switchAcademy(academy.uuid)"
                      class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md text-white bg-bpblue hover:bg-blue-500 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                      </svg>
                      Seleccionar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import AcademyService from "@/services/academy/AcademyService";
import NotificationService from "@/services/notification/NotificationService";
import {useAuthUserStore} from "@/stores/auth";

export default {
  name: "AcademiesListComponent",
  components: {},
  setup() {
    const authUserStore = useAuthUserStore()
    return { authUserStore }
  },
  data() {
    return {
      academies: [],
      selectedAcademyUuid: localStorage.getItem('selectedAcademyUuid'),
      general: {
        loading: false,
        isCorporatePlan: false,
      },
    };
  },
  created() {
    this.general.isCorporatePlan =
      this.authUserStore.user.academy.saas_subscriptions[0]?.saas_plan?.key === 'plan_corporate';

    if (this.general.isCorporatePlan) {
      this.getAcademies();
    }
  },
  methods: {
    switchAcademy(academyUuid) {
      this.authUserStore.selectAcademy(academyUuid)
    },
    getAcademies() {
      this.general.loading = true;
      AcademyService.index()
        .then((response) => {
          this.academies = response.data ?? [];
          console.log("Academias obtenidas: ", this.academies);
        })
        .catch((error) => {
          console.log("Error al obtener las academias", error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((err) => {
              NotificationService.showNotification(err, "error");
            });
          } else {
            NotificationService.showNotification(
              "Ha ocurrido un error inesperado",
              "error"
            );
          }
        })
        .finally(() => {
          this.general.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
